import { useSearchStore } from '@/stores/feed/searchStore'
import type { CharacteristicFilterType } from '@/types'

export const CARRIED_CHARACTERISTIC_CODES: ReadonlySet<number> = new Set([1216])

export function pickCarriedCharacteristics<
  T extends Pick<CharacteristicFilterType, 'code'>,
>(characteristics: T[]): T[] {
  return characteristics.filter((c) => CARRIED_CHARACTERISTIC_CODES.has(c.code))
}

export function getCarriedCharacteristics() {
  return pickCarriedCharacteristics(
    useSearchStore.getState().currentlySearchableCharacteristics
  )
}
